import { styled } from '@mui/system'
import { Grid as MuiGrid } from '@mui/material'

const Grid = styled(MuiGrid)`
	margin-top: 60px;
	.MuiAccordion-root:first-of-type {
		border: none;
	}
	.MuiAccordionSummary-content .MuiTypography-root {
		font-family: var(--font-alternative-bold);
		letter-spacing: 0.03em;
	}
	.MuiAccordionDetails-root {
		line-height: 22px;
	}
`

const GridBottom = styled(MuiGrid)`
	padding: 0 17px;
`

export { Grid, GridBottom }
